$( document ).on('turbo:load', "#custom_form_field_element_type", function () {
    $('.add-options').empty();
    $('.validation_select').find('option').remove();
    $('.validation_select').append('<option>Loading...</option>').val('Loading...');
    $('.validation_value_field').val('');
    $('.validation_message_field').val('');
    var type = $('#custom_form_field_element_type').val();
    $('.add-options').data('type', type);
    fieldTypeChange(type);
});

function fieldTypeChange(element_type) {
    var url = document.location.protocol + '//' + document.location.host + document.location.pathname;
    $.ajax({
        url: url,
        dataType: "script",
        type: 'GET',
        cache: true,
        data: {
            custom_form_field: {element_type: element_type}
        },
        success: function () {
            $.ajax({
                url: url,
                dataType: "json",
                type: 'GET',
                cache: true,
                data: {
                    custom_form_field: {element_type: element_type}
                },
                success: function (data) {
                    $('.validation_select').find('option').remove();
                    $('.validation_select').append('<option>Please, select...</option>').val('Please, select...');
                    $('#validations').data('validation_types', $(data.validation_types));
                    for (var i = 0; i < $('#validations').data('validation_types').length; i++) {
                        var value = $('#validations').data('validation_types')[i];
                        $('.validation_select').append('<option value=' + value + '>'+value+'</option>');
                    }

                }
            })
        }
    });
}
